"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.delete.confirm.title': 'Elimina Professione',
    'profession.delete.confirm.message': 'Sei sicuro di voler eliminare questa professione?',
};
